/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Ik_Cirkel_MotorischInputs */

const nl_rapporten_config_elements_ik_cirkel_motorisch = /** @type {(inputs: Rapporten_Config_Elements_Ik_Cirkel_MotorischInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik-cirkel (motorisch)`)
};

/**

* @param {Rapporten_Config_Elements_Ik_Cirkel_MotorischInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_ik_cirkel_motorisch = /** @type {((inputs?: Rapporten_Config_Elements_Ik_Cirkel_MotorischInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Ik_Cirkel_MotorischInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_ik_cirkel_motorisch(inputs)
});
export { rapporten_config_elements_ik_cirkel_motorisch as "rapporten.config.elements.ik_cirkel_motorisch" }